import { render, staticRenderFns } from "./UserPasswordEditor.vue?vue&type=template&id=19592130&"
import script from "./UserPasswordEditor.vue?vue&type=script&lang=js&"
export * from "./UserPasswordEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports